import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-daily-driver-checks-graph',
    templateUrl: './daily-driver-checks-graph.component.html',
    styleUrls: ['./daily-driver-checks-graph.component.scss'],
    standalone: false
})
export class DailyDriverChecksGraphComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
